
<div class="overlay-container" >
</div> 
<div class="modal show" id="myModal" >
 <div class="modal-dialog modal-lg">
    <div class="modal-content modal-bg">
      <!-- Modal body -->
      <div class="modal-body">
        <!-- <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
        <div id="addorUpdat" class="mt-4 mb-4">Choose Your Plate</div> -->
          
            <div class="row no-margin">
                <div class="col-12 col-sm-12 mb-4 mt-4">
                    Are you sure you wish to delete the {{tag}}?
                </div>
                  
                
              
                  
                        
                        <div class="col-12 col-sm-12 mb-3">
                            <a>
                                <button class="btn btn-primary btn-commonbtn m-auto" (click)="remove()">Yes, Delete it </button>
                            </a>
                     </div> 
                        <div class="col-12 col-sm-12 mb-3">
                            <a>
                                <button class="btn btn-primary btn-commonbtn m-auto"  (click)="cancel()" >No </button>
                            </a>
                     </div>  
              </div>          
        </div>

    </div>
  </div>
</div>